module.exports = __webpack_public_path__ + "static/04-fce0e1a72971ccc22bfeef34f352c829.jpg";